import Bugsnag from '@bugsnag/js';
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorPage } from './ErrorPage';
const myErrorHandler = (error: Error, info: { componentStack: string }) => {
  // Do something with the error
  console.log('error', error);
  console.log('info', info);
  try {
    Bugsnag.notify({
      name: 'Page crash error from layoutErrorBoundary',
      message: `Page is broken. ${JSON.stringify(error)}`,
    });
  } catch (_err) {
    // error in bugsnag
  }
};

interface Props {
  children: React.ReactNode;
}

export const LayoutErrorBoundary = (props: Props) => (
  <ErrorBoundary
    FallbackComponent={ErrorPage}
    onReset={() => {
      // reset the state of your app so the error doesn't happen again
    }}
    onError={myErrorHandler}>
    {props.children}
  </ErrorBoundary>
);
